module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/telephone-8b6c1070f7cedd2ae17f7034737bf933.svg";